module.exports = {"371372001":"芝麻墩街道","371372002":"梅埠街道","371372003":"朝阳街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371372.json
// module id = 1470
// module chunks = 0